import React from "react";
import "../App.css";
import Fire from "../config/Fire";
import InfiniteScroll from 'react-infinite-scroll-component';
import RenderPost from "../utils/Post/RenderPost";
import Aux from "../utils/AuxFunctions";
import { withMyDataContext } from "../context/DataProvider";
import ProfileHeader from "./ProfileHeader";
import Loader from "../utils/Utilities/Loader";
import LoadingHelper from "../utils/Utilities/LoadingHelper";

const LIMIT = 10;
const DEFAULT_TYPE = "myPosts"
class MyProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postsData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            loadType: "myPosts",
            user: this.props.myDataProvider.user,
            userNotFound: false,
            show: true,
        }
    }
    username = "";

    componentDidMount() {
        try {
            this.getAllData(true, this.state.loadType)
        } catch (error) {
            Aux.handleError(error)
        }
    }


    componentDidUpdate(prevProps, prevState) {
        if (prevState.loadType !== this.state.loadType) {
            this.getAllData(true, this.state.loadType || DEFAULT_TYPE,);
        } else if (this.props.myDataProvider.user !== null && prevState.user !== this.props.myDataProvider.user) {
            this.setState({ user: this.props.myDataProvider.user })
        }
    }

    onClick = (type) => {
        this.setState({ loadType: type })
    }

    signOut = () => {
        try {
            Fire.shared.signOutUser();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getAllData = async (isStart, type) => {
        if (this.state.loading) return;

        let lastVisible = null;

        if (isStart) {
            this.setState({
                postsData: [],
                finished: false,
                lastVisible: null,
                //category: cat,
            });
        } else {
            lastVisible = this.state.lastVisible
        }
        try {
            this.setState({ loading: true })
            Fire.shared
                .GetPostsData(type, lastVisible, LIMIT)
                .then(snapshot => {
                    if (snapshot) {

                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        this.setState({
                            postsData: [...this.state.postsData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });

                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error)
        }
    };

    RenderItem = (props) => {
        switch (this.state.loadType) {
            case "myComments":
                return <RenderPost comment={props.item}></RenderPost>
            case "myLikes":
                return <RenderPost post={props.item} liked={true}></RenderPost>
            case "myPosts":
                return <RenderPost post={props.item} noProfile={true}></RenderPost>
            default:
                return <RenderPost post={props.item} ></RenderPost>
        }
    }

    render() {
        return (
            <div className="content-home" style={{ display: "flex", flexDirection: "column", width: "100%" }}>

                {this.props.myDataProvider.user ?
                    <div>
                        <ProfileHeader user={this.state.user}></ProfileHeader>

                        <div style={{display: "flex", justifyContent: "flex-start", borderBottom: "2px solid #ddd", padding: "15px 35px" }}>
                            <div style={{ color: "grey", textDecoration: "none", marginRight: 20, cursor: "pointer" }} onClick={() => this.onClick("myPosts")} >
                                <h3 style={{ color: this.state.loadType === "myPosts" ? "black" : "grey" }}>Posts</h3>
                            </div>
                            <div style={{ color: "grey", textDecoration: "none", marginRight: 20, cursor: "pointer" }} onClick={() => this.onClick("myLikes")}>
                                <h3 style={{ color: this.state.loadType === "myLikes" ? "black" : "grey" }}>Likes</h3>
                            </div>
                            <div style={{ color: "grey", textDecoration: "none", marginRight: 20, cursor: "pointer" }} onClick={() => this.onClick("myComments")}>
                                <h3 style={{ color: this.state.loadType === "myComments" ? "black" : "grey" }}>Comments</h3>
                            </div>
                        </div>

                        <InfiniteScroll
                            dataLength={this.state.postsData.length}
                            next={() => this.getAllData(false, this.state.loadType || DEFAULT_TYPE)}
                            hasMore={!this.state.finished}
                            initialScrollY={0}
                            scrollableTarget="sideBar"
                            loader={<div style={{ marginTop: 20 }}><Loader color={"#999"}></Loader></div>}
                            endMessage={
                                <div style={{ marginTop: 20 }}>
                                    {this.state.postsData.length === 0 ?
                                        <p style={{ textAlign: 'center' }}>
                                            <b>You don't have any posts yet.</b>
                                        </p>
                                        :
                                        <p style={{ textAlign: 'center' }}>
                                            <b>You don't have more posts.</b>
                                        </p>}
                                </div>
                            }
                        >
                            {this.state.postsData.map((item, index) => (
                                <this.RenderItem item={item} key={item.id + index} />
                            ))}
                        </InfiniteScroll>
                    </div>
                    :
                    <div style={{marginTop:30}}>
                        <LoadingHelper></LoadingHelper>
                    </div>
                }
            </div>

        );
    }
}

export default withMyDataContext(MyProfile);
